export const DEFAULT_PAGE_SIZE = 50

export const defaultListSorting = [{ id: 'id', desc: true }]
